export default {"src":"/_next/static/media/RetailTagIconRed.159efa2d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};